var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.458 2.219c.394.273.601.746.527 1.218l-2.5 16.247a1.252 1.252 0 0 1-1.719.96l-4.672-1.94-2.675 2.894a1.25 1.25 0 0 1-2.168-.852v-3.265a.61.61 0 0 1 .164-.418L14.96 9.92a.625.625 0 0 0-.875-.887L6.14 16.091l-3.45-1.726A1.244 1.244 0 0 1 2 13.283c-.012-.46.23-.89.628-1.12l17.5-9.999a1.254 1.254 0 0 1 1.329.055Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBlackIcon);
export default __webpack_public_path__ + "static/media/send-black-icon.82a45635c3ab573891271c85c6afd9ba.svg";
export { ForwardRef as ReactComponent };